export default __webpack_public_path__ + "static/media/empty-featured-image.0c075a3c.svg";